import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Typography,
  IconButton,
  Grid,
  Popover,
  Button,
} from "@material-ui/core";
import { Close as Times } from "@material-ui/icons";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import TodayIcon from "@material-ui/icons/Today";
import DatePicker from "react-datepicker";
import useStyles, { Wrapper } from "./styles";
import { translate as t } from "../../../infrastructure/translate/localization";

const getFirstMonthDay = (dist = 0) => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + dist, 1);
};

const getLastMonthDay = (dist = 0) => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1 + dist, 0);
};

const getFirstYearDay = () => new Date(new Date().getFullYear(), 0, 1);

const getLastYearDay = () => new Date(new Date().getFullYear(), 12, 0);

export default function DateFilter({ title, onChange }) {
  const {
    container,
    label,
    icon,
    date,
    customButtons,
    continueButton,
    resetIcon,
  } = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState(null);
  const [opened, setOpened] = useState(false);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
    setAnchorEl(null);
  };

  const handleChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleConfirm = () => {
    onChange({ start: startDate, end: endDate });
    handleClose();
  };

  const reset = (e) => {
    e.stopPropagation();

    setStartDate(null);
    setEndDate(null);
    handleClose();
    onChange(null);
  };

  const handleAllMonth = () => {
    setStartDate(getFirstMonthDay());
    setEndDate(getLastMonthDay());
  };

  const handleAllLastMonth = () => {
    setStartDate(getFirstMonthDay(-1));
    setEndDate(getLastMonthDay(-1));
  };

  const handleAllYear = () => {
    setStartDate(getFirstYearDay());
    setEndDate(getLastYearDay());
  };

  return (
    <>
      <form
        className={container}
        noValidate
        onClick={handleOpen}
        role="presentation"
      >
        <Grid
          container
          justifyContent="space-between"
          spacing={1}
          direction="row"
          alignItems="center"
        >
          <Grid item className={`capitalize ${label}`}>
            {t("common-messages.date-from")}:
          </Grid>
          <Grid item className={date}>
            {startDate ? format(startDate, "dd/MM/yyyy") : "--/--/----"}
          </Grid>

          <Grid item className={`capitalize ${label}`}>
            {t("common-messages.date-to")}:
          </Grid>
          <Grid item className={date}>
            {endDate ? format(endDate, "dd/MM/yyyy") : "--/--/----"}
          </Grid>

          <Grid item>
            <IconButton
              size="small"
              style={{ backgroundColor: "transparent" }}
              disableRipple
            >
              <TodayIcon className={icon} />
            </IconButton>
          </Grid>
        </Grid>
      </form>

      <Popover
        anchorEl={anchorEl}
        keepMounted
        open={opened}
        onClose={handleClose}
      >
        <Wrapper>
          <Grid container spacing={2} justifyContent="center">
            <Grid
              container
              item
              className={label}
              justifyContent="space-between"
            >
              <Grid item>{title}</Grid>
              <Grid item onClick={reset}>
                <Times size={16} className={resetIcon} />
              </Grid>
            </Grid>
            <Grid container spacing={2} item>
              <Grid item>
                <Button
                  variant="outlined"
                  className={customButtons}
                  onClick={handleAllMonth}
                >
                  {t("common-messages.this-month")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  className={customButtons}
                  onClick={handleAllLastMonth}
                >
                  {t("common-messages.last-month")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  className={customButtons}
                  onClick={handleAllYear}
                >
                  {t("common-messages.this-year")}
                </Button>
              </Grid>
            </Grid>
            <Grid item>
              <DatePicker
                selected={startDate}
                onChange={handleChange}
                monthsShown={2}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                inline
                formatWeekDay={(nameOfDay) => (
                  <Typography variant="body2">
                    {nameOfDay.substr(0, 1)}
                  </Typography>
                )}
              />
            </Grid>
            <Grid container justifyContent="flex-end">
              <Button
                disabled={!startDate || !endDate}
                onClick={handleConfirm}
                className={continueButton}
              >
                {t("actions.continue")}
              </Button>
            </Grid>
          </Grid>
        </Wrapper>
      </Popover>
    </>
  );
}

DateFilter.defaultProps = {
  title: t("common-messages.date-range"),
  onChange: () => null,
};

DateFilter.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
};
